<template>
    <form class="selector" @submit.stop.prevent="updateValue($event)">
        <div class="form-group">
            <label :for="parameter" v-html="parameters.title.value"></label>

            <div class="form-group form-group-selectr">
                <input
                    :id="parameter"
                    type="number"
                    class="form-control"
                    :name="parameter"
                    v-model.number="value"
                    :min="range.min"
                    :max="range.max"
                    :step="range.interval"
                    @input.stop.prevent="updateValue($event)"
                >
            </div>
        </div>
        <div class="form-group">
            <div class="form-group form-group-selectr">
                <p class="tip" v-if="this.range.min" v-html="`Enter a value from ${this.range.min} to ${this.range.max}`"></p>
            </div>
        </div>
    </form>
</template>

<script>
    import VisibleSelectorWidget from './VisibleSelectorWidget.vue';

    export default {
        extends: VisibleSelectorWidget,
        data() {
            return {
                parameter: null,
                range: {},
            }
        },
        created() {
            this.registerParameterListeners(this.parameters, [
                'title'
            ]);
        },
        methods: {
            async update(data) {
                if (data.display === 'none') {
                    return this.$el.closest('.page-widget').hidden = true;
                }

                this.parameter = data.parameter;
                this.range = data.range;
                this.setValue();
            },
            updateValue(event, value = null) {
                if (! this.validate()) {
                    return this.feedback();
                }

                this.broadcast(value ? value : event.target.value);
            },
            validate() {
                return this.value === ''
                    || (this.value >= this.range.min
                    && this.value <= this.range.max
                    && (this.value % this.range.interval) === 0);
            },
            feedback() {
                return flash(`${this.parameters.title.value} is invalid. Please choose a number from ${this.range.min} to ${this.range.max}`, 'error');
            },
            broadcast(value) {
                const eventName = 'update' + this.parameter.replace(/^\w/, c => c.toUpperCase());
                window.events.emit(eventName, value);
            }
        }
    }
</script>
